<template>
  <div class="filter-comp">
    <h3>{{ titre }}</h3>
    <div class="filter-comp-wrap">
      <div class="input-wrapper">
        <input type="text" v-model="search" placeholder="Rechercher" />
      </div>
      <vue-custom-scrollbar class="list-area" :settings="settings">
        <data-filter-list
          :list="filterList"
          :type-radio="!multiSelect"
          :type="type"
          @selected="handleSelect"
          @multiSelect="handleMultiSelect"
          :linkedData="linkedData"
        >
        </data-filter-list>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import dataFilterList from './dataFilterList'
import Fuse from 'fuse.js'
export default {
  components: {
    dataFilterList,
    vueCustomScrollbar
  },
  props: {
    type: String,
    titre: String,
    list: Array,
    keys: Array,
    multiSelect: false,
    linkedData: Array
  },
  created () {
    const options = {
      shouldSort: true,
      tokenize: true,
      matchAllTokens: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 2,
      keys: this.keys
    }

    this.fuse = new Fuse(this.list, options)
  },
  methods: {
    handleSelect (id, type) {
      this.$emit('selected', id, type)
    },
    handleMultiSelect (values) {
      this.$emit('multiSelect', values)
    }
  },
  computed: {
    filterList () {
      if (!this.search) {
        return this.list
      }
      return this.fuse.search(this.search)
    }
  },
  data () {
    return {
      search: '',
      allSelected: false,
      indeterminate: false,
      fuse: null,
      settings: {
        maxScrollbarLength: 60
      }
    }
  }
}
</script>
<style lang="scss">
#filterAndListingModal {
  .modal-body {
    padding-left: 35px;
    padding-right: 35px;
  }
}
.filter-comp {
  padding: 0 10px;
  h3 {
    font-weight: 600;
    font-size: 15px;
    padding-left: 10px;
    padding-right: 10px;
    text-align: center;
    background-color: #9395c1;
    color: #fff;
    border-radius: 3px;
    height: 25px;
    line-height: 25px;
  }
}
.filter-comp-wrap {
  box-shadow: inset 0 0 0 0 #2b3085, 0px 0px 7px 0 rgba(0, 0, 0, 0.1);
  height: 100%;

  .input-wrapper {
    background-color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    input {
      width: 100%;
      border-radius: 3px;
      box-shadow: none;
      border: 1px solid #2b3085;
      font-size: 13px;
      padding-left: 10px;
      height: 25px;
      color: #2b3085;
      &::placeholder {
        color: #2b3085;
      }
    }
  }
}
.list-area {
  height: calc(100vh - 350px);
  // margin-right: -15px;
  // padding-right: 15px;
  .ps__thumb-x,
  .ps__thumb-y {
    background-color: #2b3085 !important;
    width: 6px !important;
    right: 0;
    &:hover {
      background-color: #2b3085;
      width: 6px;
    }
  }
  .ps__rail-y {
    /*display: block;*/
    width: 8px;
    border: 1px solid #2b3085;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/dataFilterContainer.vue